import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  SupportCenterContentViewModel,
  SupportCenterCardClick,
} from '@app/support-center/model/support-center-model';
import { PlatformEnum } from '@panamax/app-state';
import { ServiceRequestType, SousStatus } from '@usf/list-types';

@Component({
  selector: 'app-support-center-card',
  templateUrl: './support-center-card.component.html',
  styleUrls: ['./support-center-card.component.scss'],
})
export class SupportCenterCardComponent {
  @Input() supportItem: SupportCenterContentViewModel;
  @Input() platform: PlatformEnum;
  @Input() index: number;
  @Output() resubmitEvent = new EventEmitter<SupportCenterContentViewModel>();
  @ViewChild('supportCenterPopover') popover;
  @Output()
  cardClickEmitter: EventEmitter<SupportCenterContentViewModel> =
    new EventEmitter();

  platformRef = PlatformEnum;
  requestRef = ServiceRequestType;
  statusRef = SousStatus;

  openPopover = false;

  timeoutFunc;
  constructor() {}

  onResubmitClick = event => {
    event.stopPropagation();
    this.resubmitEvent.emit(this.supportItem);
  };

  popoverInteraction = (event: any, interact: boolean) => {
    event.stopPropagation();
    if (event !== undefined) {
      this.popover.event = event;
      this.timeoutFunc = setTimeout(() => {
        this.openPopover = false;
      }, 5000);
    }
    this.openPopover = interact;
  };

  onCardClick(event, supportItem) {
    event.stopPropagation();
    this.cardClickEmitter.emit(supportItem);
  }
}
